import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

/**Import Styles and Assets */
import styles from "./CashOutRequest.module.scss";

/**Import Components */
import { useCashOutRequestsHeader } from "../../schemas/tableHeaderSchema";
import TableLayout from "../../components/TableLayout";
import { fetchCashOutThunk } from "../../features/CashOutReducer";
import ModalContainer from "../../components/Modal/ModalContainer";
import { MdOutlineCancel } from "react-icons/md";
import { resetValue } from "../../features/SearchReducer";


export default function CashOutRequest() {
    const header = useCashOutRequestsHeader(handleModalOpen);
    const { data, status } = useSelector(state => state.cashOut);
    const { search } = useSelector(state => state.search);
    const [list, setList] = useState(data);
    const [modal, setModal] = useState({
        isOpen: false,
        data: {},
    })
    const dispatch = useDispatch();

    useEffect(() => {
        if (status !== "success") {
            dispatch(fetchCashOutThunk());
        }
        return () => dispatch(resetValue())
    }, [])

    useEffect(() => {
        if (!search) return setList(data);


        const array = [
            ...data.map(item => {
                if (item.username.toLowerCase().includes(search.toLowerCase())) {
                    return item
                }
            })
        ].filter(Boolean)
        setList(array);

    }, [data, search])

    const handleModaClose = () => {
        setModal(prev => {
            return {
                ...prev,
                isOpen: false
            }
        })
    }

    function handleModalOpen(record) {
        setModal(prev => {
            return {
                ...prev,
                isOpen: true,
                data: record
            }
        })
    }
    return (
        <div className={styles.cashOutRequest}>
            {!modal.isOpen ? "" :
                <ModalContainer handleClose={handleModaClose}>
                    <div className={styles.modal}>
                        <div className={styles.headerContainer}>
                            <h2 className={styles.title}>Bank Details</h2>
                            <span className={styles.cancelButton} onClick={handleModaClose}><MdOutlineCancel /></span>
                        </div>
                        <div className={styles.contentContainer}>
                            <p className={styles.info}><span>First Name :</span>{modal.data.first_name || '----'}</p>
                            <p className={styles.info}><span>Last Name :</span>{modal.data.last_name || '----'}</p>
                            <p className={styles.info}><span>SSN :</span>{modal.data.ssn || '----'}</p>
                            <p className={styles.info}><span>Account No :</span>{modal.data.account_no || '----'}</p>
                            <p className={styles.info}><span>Routing No :</span>{modal.data.routing_no || '----'}</p>
                            <p className={styles.info}><span>Holder Name :</span>{modal.data.holder_name || '----'}</p>
                        </div>

                    </div>
                </ModalContainer>}

            <h1 className={styles.contentTitle}>Cash Out Requests</h1>
            <TableLayout
                headers={header}
                data={list}
                status={status}
            />
        </div>
    )
}